import { createSlice } from "@reduxjs/toolkit";
import {
  getAllEtraveFlights,
  getAllFlights,
  setFilterAsync,
  setSortTypeAsync,
} from "./services/flight.services";
import {
  filterComboFlights,
  filterFlights,
  filterNewFlights,
  groupComboFlights,
  sortComboFlights,
  sortFlights,
  sortNewFlights,
} from "../../_helpers/flightUtils";

const initialState: any = {
  loading: false,
  filterLoading: false,
  error: "",
  flightData: {},
  filteredOnwardFlights: [],
  onwardFilters: {
    stop: [],
    airline: [],
    departureTime: [],
    arrivalTime: [],
    farePolicy: [],
    // priceRange: {
    //   min: 0,
    //   max: 0,
    //   selectedMin: 0,
    //   selectedMax: 0,
    // },
  },
  onwardSortType: {
    field: "price",
    order: "asc",
  },
  returnFilters: {
    stop: [],
    airline: [],
    departureTime: [],
    arrivalTime: [],
    farePolicy: [],
    // priceRange: {
    //   min: 0,
    //   max: 0,
    //   selectedMin: 0,
    //   selectedMax: 0,
    // },
  },
  returnSortType: {
    field: "price",
    order: "asc",
  },
  multicityFilters: [],
  multicitySortTypes: [],
  filteredMulticityFlights: [],
  comboFilters: [],
  comboSortType: {
    field: "price",
    order: "asc",
  },
  filteredComboFlights: [],
  multicityActiveIndex: 0,
  comboActiveIndex: 0,
};

const flightSlice = createSlice({
  name: "flight",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.onwardFilters = { ...state.onwardFilters, ...action.payload };
      // const filteredOnwardFlights = filterFlights(
      //   state.flightData?.searchResult?.tripInfos?.ONWARD,
      //   state.onwardFilters
      // );
      const filteredOnwardFlights = filterNewFlights(
        (state.etraveFlightData?.TripDetails &&
          state.etraveFlightData?.TripDetails[0]?.Flights) ||
          [],
        state.onwardFilters
      );

      // const sortedFilteredFlights = sortFlights(
      //   filteredOnwardFlights,
      //   state.onwardSortType
      // );
      const sortedFilteredFlights = sortNewFlights(
        filteredOnwardFlights,
        state.onwardSortType
      );
      state.filteredOnwardFlights = sortedFilteredFlights;
    },
    // setSortType(state, action) {
    //   state.onwardSortType = action.payload;
    //   state.filteredOnwardFlights = sortFlights(
    //     [...state.filteredOnwardFlights],
    //     state.onwardSortType
    //   );
    // },
    setSortType(state, action) {
      state.onwardSortType = action.payload;
      state.filteredOnwardFlights = sortNewFlights(
        [...state.filteredOnwardFlights],
        state.onwardSortType
      );
    },
    setReturnFilter(state, action) {
      state.returnFilters = { ...state.returnFilters, ...action.payload };
      const filteredReturnFlights = filterNewFlights(
        state.etraveFlightData?.TripDetails &&
          state.etraveFlightData?.TripDetails[1]?.Flights,
        state.returnFilters
      );
      const sortedFilteredFlights = sortNewFlights(
        filteredReturnFlights,
        state.returnSortType
      );
      state.filteredReturnFlights = sortedFilteredFlights;
    },
    setReturnSortType(state, action) {
      state.returnSortType = action.payload;
      state.filteredReturnFlights = sortNewFlights(
        [...state.filteredReturnFlights],
        state.returnSortType
      );
    },
    setMulticityFilter(state, action) {
      state.multicityFilters = action.payload;
      state.filteredMulticityFlights = (
        Object.values(
          state.flightData?.searchResult?.tripInfos || {}
        ) as any[][]
      ).map((flightList: any[], index: number) => {
        const filteredFlights = filterFlights(
          flightList,
          state.multicityFilters[index]
        );
        return sortFlights(filteredFlights, state.multicitySortTypes[index]);
      });
    },
    setMulticitySortType(state, action) {
      const { sortType, index } = action.payload;
      state.multicitySortTypes[index] = sortType;
      state.filteredMulticityFlights[index] = sortFlights(
        filterFlights(
          state.flightData?.searchResult?.tripInfos[index],
          state.multicityFilters[index]
        ),
        sortType
      );
    },
    setMulticityActiveIndex(state, action) {
      state.multicityActiveIndex = action.payload;
    },
    setComboActiveIndex(state, action) {
      state.comboActiveIndex = action.payload;
    },
    setFilterLoading(state, action) {
      state.filterLoading = action.payload;
    },

    setComboFilters(state, action) {
      // state.filterLoading = true;
      state.comboFilters = action.payload;

      const comboFlights =
        state.flightData?.searchResult?.tripInfos?.COMBO || [];

      const groupedFlights = groupComboFlights(comboFlights);

      const filteredComboFlights = filterComboFlights(
        groupedFlights,
        state.comboFilters
      );

      const sortedFilteredComboFlights = sortComboFlights(
        filteredComboFlights,
        state.comboSortType,
        state.comboActiveIndex
      );
      state.filteredComboFlights = sortedFilteredComboFlights;

      // setTimeout(() => {
      //   state.filterLoading = false;
      // }, 500);
    },

    setComboSortType(state, action) {
      state.comboSortType = action.payload;
      state.filteredComboFlights = sortComboFlights(
        [...state.filteredComboFlights],
        state.comboSortType,
        state.comboActiveIndex
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFlights.pending, (state) => {
      state.loading = true;
      state.onwardFilters = initialState.onwardFilters;
      state.onwardSortType = initialState.onwardSortType;
      state.returnFilters = initialState.returnFilters;
      state.returnSortType = initialState.returnSortType;
      state.multicityFilters = initialState.multicityFilters;
      state.multicitySortTypes = initialState.multicitySortTypes;
      state.flightData = {};
      state.filteredOnwardFlights = [];
      state.filteredReturnFlights = [];
      state.filteredMulticityFlights = [];
      state.filteredComboFlights = [];
    });
    builder.addCase(getAllFlights.fulfilled, (state, action) => {
      state.loading = false;
      state.flightData = action.payload;

      const onwardFlights = action.payload?.searchResult?.tripInfos?.ONWARD;
      const returnFlights = action.payload?.searchResult?.tripInfos?.RETURN;
      const comboFlights = action.payload?.searchResult?.tripInfos?.COMBO || [];
      const multicityFlights = action.payload?.searchResult?.tripInfos?.["0"];

      const groupedFlights = groupComboFlights(comboFlights);

      while (
        state.comboFilters.length <
          (groupedFlights?.length > 0 && groupedFlights[0]?.length) ||
        0
      ) {
        state.comboFilters.push({
          stop: [],
          airline: [],
          departureTime: [],
          arrivalTime: [],
          farePolicy: [],
          // priceRange: {
          //   min: 0,
          //   max: 0,
          //   selectedMin: 0,
          //   selectedMax: 0,
          // },
        });
      }

      state.filteredOnwardFlights = onwardFlights
        ? sortFlights(onwardFlights, state.onwardSortType)
        : [];
      state.filteredReturnFlights = returnFlights
        ? sortFlights(returnFlights, state.returnSortType)
        : [];

      state.filteredMulticityFlights = multicityFlights
        ? (
            Object.values(
              action.payload?.searchResult?.tripInfos || {}
            ) as any[][]
          ).map((flightList: any[], index: number) => {
            if (!state.multicityFilters[index]) {
              state.multicityFilters.push({
                stop: [],
                airline: [],
                departureTime: [],
                arrivalTime: [],
                farePolicy: [],
                // priceRange: {
                //   min: 0,
                //   max: 0,
                //   selectedMin: 0,
                //   selectedMax: 0,
                // },
              });
            }

            if (!state.multicitySortTypes[index]) {
              state.multicitySortTypes.push({
                field: "price",
                order: "asc",
              });
            }

            return sortFlights(
              flightList,
              state.multicitySortTypes[index] ||
                initialState.multicitySortTypes[0]
            );
          })
        : [];

      state.filteredComboFlights = groupedFlights
        ? sortComboFlights(
            groupedFlights,
            state.comboSortType,
            state.comboActiveIndex
          )
        : [];

      state.error = "";
    });
    builder.addCase(getAllFlights.rejected, (state, action) => {
      state.loading = false;
      state.flightData = {};
      state.filteredOnwardFlights = [];
      state.filteredReturnFlights = [];
      state.filteredMulticityFlights = [];
      state.filteredComboFlights = [];

      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllEtraveFlights.pending, (state) => {
      state.loading = true;
      state.etraveFlightData = {};
      state.onwardFlights = [];
      state.onwardFilters = initialState.onwardFilters;
      state.onwardSortType = initialState.onwardSortType;
      state.returnFilters = initialState.returnFilters;
      state.returnSortType = initialState.returnSortType;
      state.filteredOnwardFlights = [];
      state.filteredReturnFlights = [];
    });
    builder.addCase(getAllEtraveFlights.fulfilled, (state, action) => {
      const onwardNewFlights =
        (action.payload?.TripDetails &&
          action.payload?.TripDetails[0]?.Flights) ||
        [];
      const returnNewFlights =
        (action.payload?.TripDetails &&
          action.payload?.TripDetails[1]?.Flights) ||
        [];

      state.loading = false;
      state.etraveFlightData = action.payload;
      state.onwardFlights = onwardNewFlights || [];
      state.filteredOnwardFlights = onwardNewFlights
        ? sortNewFlights(onwardNewFlights, state.onwardSortType)
        : [];
      state.filteredReturnFlights = returnNewFlights
        ? sortNewFlights(returnNewFlights, state.returnSortType)
        : [];
    });
    builder.addCase(getAllEtraveFlights.rejected, (state) => {
      state.loading = false;
      state.etraveFlightData = {};
      state.filteredOnwardFlights = [];
      state.filteredReturnFlights = [];
    });
    builder.addCase(setSortTypeAsync.pending, (state) => {
      state.filterLoading = true;
    });
    builder.addCase(setSortTypeAsync.fulfilled, (state) => {
      state.filterLoading = false;
    });
    builder.addCase(setSortTypeAsync.rejected, (state) => {
      state.filterLoading = false;
    });
    builder.addCase(setFilterAsync.pending, (state) => {
      state.filterLoading = true;
    });
    builder.addCase(setFilterAsync.fulfilled, (state) => {
      state.filterLoading = false;
    });
    builder.addCase(setFilterAsync.rejected, (state) => {
      state.filterLoading = false;
    });
  },
});

export const {
  setFilter,
  setSortType,
  setReturnSortType,
  setReturnFilter,
  setMulticityFilter,
  setMulticitySortType,
  setMulticityActiveIndex,
  setComboActiveIndex,
  setComboFilters,
  setComboSortType,
  setFilterLoading,
} = flightSlice.actions;
export default flightSlice.reducer;
